import { render, staticRenderFns } from "./LiveStatisticsView.vue?vue&type=template&id=22c8af39&scoped=true"
import script from "./LiveStatisticsView.vue?vue&type=script&lang=js"
export * from "./LiveStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8af39",
  null
  
)

export default component.exports